import React from 'react';
import { connect } from 'react-redux';
import MainTitle from '../../../../components/MainTitle';
import ProposalLawyerForm from './ProposalLawyerForm';
import { Formik } from 'formik';
import { validationProposalLawyer } from '../../../../utils/validations';
import {
  cleanProposalData,
  loadProposalData,
  setProposalSelected,
} from '../../../../store/actions/ProposalsAction';
import './ProposalLawyer.scss';

const ProposalLawyer = ({
  setStep,
  setCreateView,
  valuesToEdit,
  authClient,
  loadProposalData,
  setProposalSelected,
  proposalData
}) => {

  const editFlag = (valuesToEdit && Object.values(valuesToEdit).length > 0)

  let formValues = {}
  if (editFlag) {
    formValues = {
      flagEdit: true,
      proposalImgProfile: valuesToEdit ? valuesToEdit.urlImgLogo : '',
      name: valuesToEdit ? valuesToEdit.names : '',
      lastName: valuesToEdit ? valuesToEdit.lastName : '',
      email: valuesToEdit ? valuesToEdit.email : '',
      phone: valuesToEdit ? valuesToEdit.phone : '',
      estado: valuesToEdit ? valuesToEdit.state : '',
      municipio: valuesToEdit ? valuesToEdit.municipality : '',
      address: valuesToEdit ? valuesToEdit.direction : '',
    }
  } else {
    formValues = {
      flagEdit: false,
      proposalImgProfile: proposalData.urlImgLogo ?
        proposalData.urlImgLogo :
        authClient.imgProfile ?
        authClient.imgProfile : '',
      name:
        proposalData.names ? proposalData.names :
        (authClient.name || ''),
      lastName: proposalData.lastName ? proposalData.lastName :
        (`${authClient.firstLastName} ${authClient.secondLastName}` || ''),
      email:
        proposalData.email ? proposalData.email :
        authClient.contacto && authClient.contacto.email
          ? authClient.contacto.email
          : '',
      phone:
        proposalData.phone ? proposalData.phone :
        authClient.contacto && authClient.contacto.phone
          ? authClient.contacto.phone
          : '',
      estado:
        proposalData.state ? proposalData.state :
        authClient.sede && authClient.sede.length > 0
          ? authClient.sede[0].estado
          : '',
      municipio:
        proposalData.municipality ? proposalData.municipality :
        authClient.sede && authClient.sede.length > 0
          ? authClient.sede[0].municipio
          : '',
      address:
        proposalData.direction ? proposalData.direction :
        authClient.sede && authClient.sede.length > 0
          ? authClient.sede[0].direccion
          : '',
    }
  }

  const handleSubmit = (values) => {
    delete values.flagEdit
    
    if (editFlag) {
      const newProposalData = {
        ...valuesToEdit,
        urlImgLogo: values.proposalImgProfile ,
        names: values.name ,
        lastName: values.lastName ,
        email: values.email ,
        phone: values.phone ,
        state: values.estado ,
        municipality: values.municipio ,
        direction: values.address ,
      }
      setProposalSelected(newProposalData)
    } else {
      const newProposalData = {
        ...proposalData,
        urlImgLogo: values.proposalImgProfile ,
        names: values.name ,
        lastName: values.lastName ,
        email: values.email ,
        phone: values.phone ,
        state: values.estado ,
        municipality: values.municipio ,
        direction: values.address ,
      }
      loadProposalData(newProposalData)
    }

    window.scroll(0, 0);
    setStep(2);
  };

  return (
    <>
      <div className="ProposalLawyer">
        <div className="ProposalLawyer_header">
          <div
            className="ProposalLawyer_header_arrowBack"
            onClick={() => setStep(0)}
          >
            <img src="/img/admin/arrow-back.svg" alt="arrow-back" />
            <p>Regresar</p>
          </div>
          <div className="ProposalLawyer_header_title">
            <MainTitle
              title="Datos del abogado para la propuesta económica"
              subtitle="Verifica tus datos, éstos aparecen en los membretes de las propuestas enviadas."
            />
          </div>
        </div>

        <Formik
          initialValues={formValues}
          validationSchema={validationProposalLawyer}
          onSubmit={handleSubmit}
          render={(props) => (
            <ProposalLawyerForm {...props} setCreateView={setCreateView} />
          )}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  authClient: state.authClient,
  valuesToEdit: state.proposalsReducer.selectedProposal,
  proposalData: state.proposalsReducer.newProposalData,
});

const mapDispatchToProps = (dispatch) => ({
  loadProposalData: proposalData => dispatch(loadProposalData(proposalData)),
  setProposalSelected: proposalData => dispatch(setProposalSelected(proposalData))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProposalLawyer);
